import { render, staticRenderFns } from "./DialogCheckout.vue?vue&type=template&id=f1236f7e&scoped=true"
import script from "./DialogCheckout.vue?vue&type=script&lang=js"
export * from "./DialogCheckout.vue?vue&type=script&lang=js"
import style0 from "./DialogCheckout.vue?vue&type=style&index=0&id=f1236f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1236f7e",
  null
  
)

export default component.exports